import {InfoOutlined } from "@mui/icons-material";
import {  IconButton, Tooltip } from "@mui/material";
import AppTable from "components/Shared/AppTable";
import TableFilter from "components/Shared/AppTable/TableFilter";
import { BaseTabs } from "components/Shared/BaseTabs";
import HighlightedText from "components/Shared/HighlightedText";
import { useAppMeta, useTablePagination } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useLazyGetCustomerUserListDataQuery } from "store/services/customerUserApi";

const CustomerUserListScreen = () => {
  const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
    useTablePagination();
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "Active";
  const keyword = searchParams.get("search") || "";

  const breadcrumbs = [
    {
      title: "Customer",
    },
  ];

  const customerListTabs = [
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" }

  ];


  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      cell: (row) => (
        <Link
          title={row?.name}
          to={`/app/crm/customerUser/${row._id}/detail`}
          className="line-clamp-2 hover:text-blue-600 hover:underline dark:hover:text-blue-300"
        >
          {row?.name ? (
            <HighlightedText text={row?.name} highlight={keyword} />
          ) : (
            "N/A"
          )}
        </Link>
      ),
      sortable: true,
    },
    {
      name: "User ID",
      selector: (row) => row.customerUserID,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
    },
    {
      name: "Alternate Phone",
      selector: (row) => row.alternatePhone,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex items-center gap-1">
          <Link to={`/app/crm/customerUser/${row._id}/detail`}>
            <Tooltip title="View Customer User Detail" arrow>
              <IconButton size="small" aria-label="View customer user" color="primary">
                <InfoOutlined />
              </IconButton>
            </Tooltip>
          </Link>

          {/* Edit a customer */}
          
          {/* <Link to={`/app/crm/customerUser/${row._id}/edit`} state={{ from: "list" }}>
            <Tooltip title="Edit Customer User" arrow>
              <IconButton size="small" aria-label="Edit customer user">
                <ModeEditOutlineTwoTone />
              </IconButton>
            </Tooltip>
          </Link> */}
        </div>
      ),
      ignoreRowClick: true,
      right: true,
    },
  ];

  // RTK Query hook for fetching customer users
  const [
    fetchCustomerUsers,
    {
      data: customerUserRes,
      isLoading: loadingCustomerUsers,
      isFetching: fetchingCustomerUsers,
      error,
    },
  ] = useLazyGetCustomerUserListDataQuery();

  React.useEffect(() => {
    fetchCustomerUsers({
      active: activeTab === "Active",
      page: currentPage,
      limit: perPage,
      ...(keyword && { search: keyword }),
    });
  }, [activeTab, currentPage, perPage, keyword, fetchCustomerUsers]);
  useAppMeta(`${activeTab} CustomerUser`);


  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} headerActions={<PageActions />}>
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <BaseTabs
          tabs={customerListTabs}
          defaultValue={activeTab}
        />
        <TableFilter searchLabel="Name" disabled={loadingCustomerUsers || fetchingCustomerUsers}>
        </TableFilter>

        <AppTable
          columns={columns}
          data={customerUserRes?.data ?? []}
          progressPending={loadingCustomerUsers || fetchingCustomerUsers}
          paginationServer
          paginationPerPage={perPage}
          paginationTotalRows={customerUserRes?.totalItems ?? 0}
          paginationDefaultPage={currentPage}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default CustomerUserListScreen;

const PageActions = () => {
  return (
    <>
    {/* <Link to="/app/crm/customerUser/create">
      <Button startIcon={<Add />} variant="contained">
        New Customer
      </Button>
    </Link> */}
    </>
  );
};
